var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReplaceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 26,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m18.827 14.43-3.73 3.73a1.477 1.477 0 0 0 2.088 2.09l5.62-5.622a2.37 2.37 0 0 0 0-3.351l-5.62-5.621a1.477 1.477 0 0 0-2.088 2.088l3.733 3.733H4.977a1.477 1.477 0 1 0 0 2.953h13.85Z",
  fill: "#767676"
})));
export default SvgReplaceIcon;